// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1eF0g","errorLogs":"EditorFooter_errorLogs__2JVrp"};